/**
 * Política de senha forte — espelha validateStrongPassword da API
 * (packages/api/src/lib/validation.ts): 8+ caracteres, maiúscula, minúscula
 * e caractere especial. Usada no signup e na troca obrigatória de senha.
 */

export interface PasswordValidation {
  minLength: boolean;
  uppercase: boolean;
  lowercase: boolean;
  special: boolean;
}

export function validatePassword(password: string): PasswordValidation {
  return {
    minLength: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
}

export function isPasswordValid(v: PasswordValidation): boolean {
  return v.minLength && v.uppercase && v.lowercase && v.special;
}
